module.exports = __webpack_public_path__ + "static/media/icon-youtube.86bda961.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-youtube.svg
// module id = 404
// module chunks = 2